interface ScreenScrollConfig {
  width: number;
  height: number;
  offset: number;
}

// Preset scroll offsets for common screen sizes
const SCREEN_SCROLL_CONFIGS: ScreenScrollConfig[] = [
  { width: 320, height: 693, offset: 75 },
  { width: 390, height: 844, offset: 10 },
  { width: 360, height: 800, offset: 10 },
  { width: 375, height: 812, offset: 12 },
  { width: 360, height: 780, offset: 15 },
  { width: 768, height: 1024, offset: 5 },
  { width: 1024, height: 768, offset: 18 },
  { width: 1280, height: 720, offset: -12 },
  { width: 1366, height: 768, offset: -20 },
  { width: 1536, height: 864, offset: -58 },
  { width: 1920, height: 1080, offset: -70 },
  { width: 2560, height: 1440, offset: 35 },
];

// Calculates the scroll position for an element considering screen-specific offset.
export const getScrollOffset = (elementTop: number): number => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  let bestMatch = SCREEN_SCROLL_CONFIGS[0];
  let bestScore = Infinity;

  for (const config of SCREEN_SCROLL_CONFIGS) {
    const widthDiff = Math.abs(screenWidth - config.width);
    const heightDiff = Math.abs(screenHeight - config.height);
    const score = widthDiff + heightDiff;

    if (score < bestScore) {
      bestScore = score;
      bestMatch = config;
    }

    if (score === 0) {
      break;
    }
  }

  return elementTop + bestMatch.offset;
};

// Smoothly scrolls to an element by ID, adjusting for screen-specific offset.
export const scrollToElementWithOffset = (
  elementId: string,
  behavior: ScrollBehavior = "smooth",
): void => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top + window.pageYOffset;
    const scrollTop = getScrollOffset(elementTop);

    window.scrollTo({
      top: scrollTop,
      behavior,
    });
  }
};
